import { Tag } from './gql/tag';

export interface SelfEvaluation {
  id: number;
  score: number;
  tag: Tag;
}
